const LAND = new Set(['gut_number', 'survey_number', 'milkat_number', 'plot_number', 'cts_number', 'bhumapan_number', 'block_number']);
const FLAT = new Set(['flat_number', 'shop_number', 'sadanika_number']);

export const matchType = (rec, type) => {
  const nums = rec.property_numbers || [];
  if (!nums.length) return true;
  return type === 'land' ? nums.some((n) => LAND.has(n.type)) : nums.some((n) => FLAT.has(n.type));
};

export const dedupe = (raw) => {
  const seen = new Set();
  return (raw || []).filter((r) => {
    if (!r?.key) return true;
    if (seen.has(r.key)) return false;
    seen.add(r.key);
    return true;
  });
};

export const partialDate = (d) => {
  const m = String(d || '').match(/(\d{1,2})[\/\-](\d{1,2})/);
  return m ? `${m[1].padStart(2, '0')}/${m[2].padStart(2, '0')}` : null;
};

export const searchUrl = (base, { d, t, v, district, taluka, village, query }) =>
  d && t && v
    ? `${base}/search?d=${d}&t=${t}&v=${v}&query=${encodeURIComponent(query)}`
    : `${base}/search?district=${encodeURIComponent(district)}&taluka=${encodeURIComponent(taluka)}&village=${encodeURIComponent(village)}&query=${encodeURIComponent(query)}`;
